import { createComponent } from '@lit/react';
import React from 'react';
import { SDSTextArea } from '../sds-textarea/sds-textarea';
import { SheriffEventName } from './types';

export const SDSTextAreaWrapper = createComponent({
	tagName: 'sds-textarea',
	elementClass: SDSTextArea,
	react: React,
	events: {
		onInput: 'input' as SheriffEventName,
		onChange: 'input' as SheriffEventName,
		onSelect: 'select' as SheriffEventName,
		onFocus: 'focus' as SheriffEventName,
		onBlur: 'blur' as SheriffEventName,
	},
});
